import { render } from "./Others7Charts.vue?vue&type=template&id=c2635eec&scoped=true"
import script from "./Others7Charts.vue?vue&type=script&lang=js"
export * from "./Others7Charts.vue?vue&type=script&lang=js"

import "./Others7Charts.vue?vue&type=style&index=0&id=c2635eec&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2635eec"]])

export default __exports__